import { render, staticRenderFns } from "./videoplay.vue?vue&type=template&id=01c348ea&scoped=true&"
import script from "./videoplay.vue?vue&type=script&lang=js&"
export * from "./videoplay.vue?vue&type=script&lang=js&"
import style0 from "./videoplay.vue?vue&type=style&index=0&id=01c348ea&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c348ea",
  null
  
)

export default component.exports